<template>
  <div class="kiosk pdf service__request sr__listPage">
    <!-- Table Container Card -->
    <b-row
      class="content-header"
    >
      <!-- Content Left -->
      <b-col
        class="content-header-left booking_content_wrapper"
        cols="12"
        md="12"
      >
        <!-- <sales-order
          :digital-form="orm && form.formID && form.formID.name || 'Sales Order'"
          :top-spacing="topSpacing"
          :request-form="form"
          :service-request="serviceRequest"
        /> -->

        <!-- <sales-orderFSP
          :digital-form="form && form.formID && form.formID.name || 'Sales Order FSP'"
          :top-spacing="topSpacing"
          :request-form="form"
          :service-request="serviceRequest"
        /> -->

        <!-- <sales-submission-niche
          :digital-form="form && form.formID && form.formID.name || 'Sales Order Niche'"
          :top-spacing="topSpacing"
          :request-form="form"
          :service-request="serviceRequest"
        /> -->

        <sales-submission-pedestal
          :digital-form="form && form.formID && form.formID.name || 'Sales Order Pedestal'"
          :top-spacing="topSpacing"
          :request-form="form"
          :service-request="serviceRequest"
        />

        <!-- <installment-form
          :digital-form="form && form.formID && form.formID.name || 'Installment Form'"
          :top-spacing="topSpacing"
          :request-form="form"
          :service-request="serviceRequest"
        /> -->

        <!-- <installment-payment-plan
          :digital-form="orm && form.formID && form.formID.name || 'Installment Payment Plan'"
          :top-spacing="topSpacing"
          :request-form="form"
          :service-request="serviceRequest"
        /> -->

        <!-- <FSPDetails-acknowledgement
          :digital-form="orm && form.formID && form.formID.name || 'FSP Details Acknowledgement'"
          :top-spacing="topSpacing"
          :request-form="form"
          :service-request="serviceRequest"
        /> -->

        <!-- <redemption-imported-urn
          :digital-form="orm && form.formID && form.formID.name || 'Sales Order FSP'"
          :top-spacing="topSpacing"
          :request-form="form"
          :service-request="serviceRequest"
        /> -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// import SalesOrder from './pdfs/SalesOrder.vue'
// import SalesOrderFSP from './pdfs/SalesOrderFSP.vue'
// import SalesSubmissionNiche from './pdfs/SalesSubmissionNiche.vue'
// import InstallmentPaymentPlan from './pdfs/InstallmentPaymentPlan.vue'
// import FSPDetailsAcknowledgement from './pdfs/FSPDetailsAcknowledgement.vue'
// import InstallmentForm from './pdfs/InstallmentForm.vue'
import SalesSubmissionPedestal from './pdfs/SalesSubmissionPedestal.vue'

export default {
  components: {
    BRow,
    BCol,

    // SalesOrder,
    // SalesOrderFSP,
    // SalesSubmissionNiche,
    // InstallmentPaymentPlan,
    // FSPDetailsAcknowledgement,
    // InstallmentForm,
    SalesSubmissionPedestal,
  },
  data() {
    return {
      topSpacing: 135,
      form: {},
      serviceRequest: {},
    }
  },
  beforeMount() {
    // this.$http.get(`download/service-form/${this.$route.params.id}/show`)
    //   .then(response => {
    //     this.form = response.data.form || {}
    //     this.serviceRequest = response.data.sr || {}
    //   })
    //   .catch(error => {
    //     this.$toast({
    //       component: ToastificationContent,
    //       props: {
    //         title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
    //         icon: 'AlertTriangleIcon',
    //         variant: 'danger',
    //       },
    //     })
    //   })
  },
}
</script>

<style>
.rounded-number {
    height: 24px;
    width: 24px;
    background-color: #FFFFFF;
    border-radius: 50%;
    color:#104D9D;
}
@media print {
  div#app.semi-dark-layout {
    background: #fff !important;
  }

  .white-background {
    background: #fff !important;
  }
}
div#app.semi-dark-layout {
    background: #fff !important;
  }

  .white-background {
    background: #fff !important;
  }
</style>
